// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"JoBt7xyu"};